// Libs
import routesToNavigationItems from './routesToNavigationItems';

// Pages
import {
  Administrators,
  Applications,
  Directories,
  General,
  Users,
  Features,
  Pages,
  PersonProfiles,
} from 'components/Router/routes';

// Types
import * as Types from '../types';

/**
 * The base Navigation hierarchy object. Adding items to this
 * will change what is on the left side. We start with the
 * max items and allow `makeNavigation` to filter items out.
 */
export const defaultNavigationItems = (): Types.InternalLinkNavItem[] => [
  {
    divider: true,
    children: routesToNavigationItems([Users, PersonProfiles, Pages, Features, General]),
  },
  {
    divider: true,
    // prettier-ignore
    children: routesToNavigationItems([
      Directories,
      Applications,
      Administrators,
    ])
  },
];

export default defaultNavigationItems;
